export const movdTokens = {
  color: {
    // legacy flat keys (do not remove — widely referenced directly by
    // MoveWorkspace/QuoteDetails/MovdButton/etc). Left unchanged so this
    // token expansion does not silently re-skin already-shipped screens.
    ink: '#07111F',
    inkSoft: '#102A3A',
    paper: '#F4F7F5',
    paperMuted: '#DCE8E4',
    text: '#F8FAFC',
    textMuted: 'rgba(248,250,252,.66)',
    teal: '#55D6BE',
    tealSoft: '#B8F3E7',
    warm: '#FFB86B',
    danger: '#FDA4AF',
    focus: '#7AE6D5',

    // proposed semantic groups for the journey rebuild (Phase 2+).
    // Not yet consumed anywhere — pending direction sign-off.
    brand: {
      ink: '#0B1B2B',
      inkSoft: '#132C3F',
      inkMuted: '#2A425A',
    },
    background: {
      canvas: '#F6F4EF',
      canvasDark: '#0B1B2B',
    },
    surface: {
      base: '#FFFFFF',
      elevated: '#FFFFFF',
      sunken: '#EFEBE1',
      onDark: '#132C3F',
      onDarkElevated: '#1B3A50',
    },
    content: {
      primary: '#0B1B2B',
      secondary: '#445062',
      muted: '#7C8798',
      onDark: '#F8FAFC',
      onDarkMuted: 'rgba(248,250,252,.66)',
      onDarkSubtle: 'rgba(248,250,252,.42)',
    },
    border: {
      subtle: '#E2E6EA',
      onDark: 'rgba(248,250,252,.18)',
    },
    action: {
      primary: '#1F8C82',
      primaryHover: '#177067',
      primaryText: '#FFFFFF',
      secondary: 'transparent',
      secondaryBorder: 'rgba(11,27,43,.24)',
      secondaryBorderOnDark: 'rgba(248,250,252,.32)',
      secondaryText: '#0B1B2B',
      secondaryTextOnDark: '#F8FAFC',
    },
    state: {
      success: '#2F7D58',
      successSurface: '#E4F2EA',
      warning: '#A96A1F',
      warningSurface: '#F7ECDA',
      error: '#B3453B',
      errorSurface: '#F6E4E2',
      selected: '#E5F3F1',
      selectedBorder: '#1F8C82',
      disabled: '#B7BEC7',
      disabledSurface: '#EDEFF1',
    },
  },
  typography: {
    fontFamily: 'Inter, "Helvetica Neue", Arial, sans-serif',
    size: { xs: 12, sm: 13, base: 15, md: 16, lg: 20, xl: 28, xxl: 40 },
    weight: { regular: 500, medium: 700, bold: 800, black: 900 },
    lineHeight: { tight: 1.1, snug: 1.3, normal: 1.5 },
  },
  space: { 1: 4, 2: 8, 3: 12, 4: 16, 5: 24, 6: 32, 7: 48 },
  radius: { none: 0, control: 10, panel: 16 },
  size: {
    fieldHeight: 52,
    buttonHeight: 48,
    controlGap: 16,
    sectionGap: 32,
    contentMaxWidth: 1440,
    formMaxWidth: 640,
  },
  shadow: {
    panel: '0 10px 30px rgba(11,27,43,.12)',
    raised: '0 4px 14px rgba(11,27,43,.08)',
  },
  breakpoint: { xs: 390, md: 768, lg: 1024, xl: 1440 },
  motion: {
    micro: '120ms cubic-bezier(.22,1,.36,1)',
    standard: '220ms cubic-bezier(.22,1,.36,1)',
  },
};

export const movdFocus = {
  outline: `3px solid ${movdTokens.color.focus}`,
  outlineOffset: 3,
};

